/**
 * Role configuration for the Readiness SPA's auth gate (SPA-Auth Standard).
 *
 * ⚠️ THIS APP IS DELIBERATELY OPEN-ACCESS: the AI Readiness Report is a
 * self-serve product — ANY signed-in Microsoft 365 organisational account may
 * generate a report. The app registration (76a99a6b-…) defines no
 * user-assignable `appRoles` that gate access, so `REQUIRED_ROLES` is empty
 * and `RootGate`-style checks treat an empty list as "no role required".
 *
 * If access ever becomes role-gated, add the app registration's
 * `appRoles[].value`s here (spelled EXACTLY as in the manifest) — the gate,
 * no-access screen, and diagnostics below it are already wired.
 *
 * Role-value matching is **case-insensitive** — Entra role-claim casing is not
 * guaranteed, so always compare via `hasAnyRole`, never `Array.includes`.
 */

/** Roles that grant access to the app (any one suffices). Empty = open access. */
export const REQUIRED_ROLES: readonly string[] = [];

/** Case-insensitive membership: does `roles` contain any value in `allowed`? */
export function hasAnyRole(roles: string[], allowed: readonly string[]): boolean {
  const allow = new Set(allowed.map((r) => r.toLowerCase()));
  return roles.some((r) => allow.has(r.toLowerCase()));
}

/**
 * Gate predicate: true when the required-role list is empty (open access) or
 * the user holds at least one required role (case-insensitive).
 */
export function meetsRoleRequirement(
  roles: string[],
  required: readonly string[] = REQUIRED_ROLES,
): boolean {
  return required.length === 0 || hasAnyRole(roles, required);
}
